export default "__VITE_ASSET__l9a1R2T___"